import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import iconClosedAlert from "../../../../assets/images/icons/iconClosedAlert.svg";
import iconInstagramColorModal from "../../../../assets/images/icons/iconInstagramColorModal.svg";
import instaImagenStories from "../../../../assets/images/image_Insta_Stories.jpg";
import iconChevronLeft from "../../../../assets/images/icons/iconChevronLeft.svg";
import iconChevronRight from "../../../../assets/images/icons/iconChevronRight.svg";
import iconCheckCircleWhite from "../../../../assets/images/icon-Check-Circle-White.svg";
import "../../../../assets/styles/scss/scss_files/general/_general.scss";

export const PCSharedInstaStories = ({ setOpenModal, setShared, pcInfo }) => {
  const [t] = useTranslation("global");
  const [changeButon, setChangeButon] = useState(false);
  const ROOT_URL = process.env.REACT_APP_MY_URL;
  const goInsta = () => {
    window.open("https://www.instagram.com", "_blank");
  };

  let image;

  switch (window?.navigator?.language?.slice(0, 2)) {
    case "es":
      image = instaImagenStories;
      break;
    case "de":
      image = instaImagenStories;
      break;
    case "en":
      image = instaImagenStories;
      break;
    default:
      image = instaImagenStories;
      break;
  }

  const handleChange = () => {
    toast.success(t("information.copiedCorrectly"));
    // window.open("https://www.instagram.com", "_blank");
    setChangeButon(true);
  };

  return (
    <>
      <div className="alert-confirmation-budget sharedLinks m-0 d-flex ">
        <div className="header-alert-budget header-link">
          <Button
            className="modalShared iconBack"
            onClick={() => setShared("links")}
          >
            <img src={iconChevronLeft} alt="instaColor" />
          </Button>
          Instagram Stories
          <Button className="closedAlert" onClick={() => setOpenModal(false)}>
            <img className="iconCheck" src={iconClosedAlert} alt="asdasd" />
          </Button>
        </div>
        <div className="sharedBody">
          <div className="divAlertConfirmation">
            <p className="text-start mb-0 pb2">
              {t("shared.instaStoriesTitle")} 
            
           
            </p>
          </div>
          <div className="sharedBodyImg">
            <img className="iconCheck" src={image} alt="asdasd" />
          </div>
          <div className="sharedBodycopy">
            <p className="bodyBold ">
              {`Link: `}
              <a
                rel="noopener noreferrer"
                className="bodyRegular"
                href={`${ROOT_URL}/` + pcInfo.domain_name}
                target="_blank"
              >
                {`${ROOT_URL}/` + pcInfo.domain_name}
              </a>
            </p>
            <CopyToClipboard text={`${ROOT_URL}/${pcInfo.domain_name}`}>
              <Button
                className={
                  changeButon === false ? "ButonRRSS" : "ButonRRSSGreen"
                }
                onClick={changeButon === false && (() => handleChange())}
              >
                {changeButon === false ? (
                  `${t("information.copy")}`
                ) : (
                  <>
                    <img
                      className="iconCheckButtonRRSS"
                      src={iconCheckCircleWhite}
                      alt=""
                    ></img>
                    <p> {t("information.copying")} </p>
                  </>
                )}
              </Button>
            </CopyToClipboard>
          </div>
        </div>
        <div className="links" onClick={() => goInsta()}>
          <Button className="modalShared">
            <img
              className="iconCheck"
              src={iconInstagramColorModal}
              alt="instaColor"
            />
            <span>{t("shared.insta")} </span>
          </Button>
          <img className="go" src={iconChevronRight} alt="go" />
        </div>
      </div>
    </>
  );
};
